import { Button } from './ui/button';
import { FileClock } from 'lucide-react';
import { fmtDateTime } from '../lib/datetime';

/** Aviso de borradores en curso (compartidos por área). */
export const DraftBanner = ({ drafts, onContinue, onDiscard, label, testid = 'draft-banner' }) => {
  if (!drafts?.length) return null;
  return (
    <div className="space-y-2" data-testid={testid}>
      {drafts.map((d) => (
        <div
          key={d.area_id}
          className="flex flex-col gap-2 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-amber-900 sm:flex-row sm:items-center sm:justify-between dark:bg-amber-950/30 dark:border-amber-800 dark:text-amber-200"
          data-testid={`draft-banner-${d.area_id}`}
        >
          <div className="flex items-start gap-2 text-sm">
            <FileClock className="mt-0.5 h-4 w-4 shrink-0" />
            <span>
              <b>{label}</b> en <b>{d.area_name || d.area_id}</b> con{' '}
              <b>{(d.payload?.items || []).length}</b> ítem(s) — guardado por {d.updated_by_name}
              {d.updated_at ? ` · ${fmtDateTime(d.updated_at)}` : ''}
            </span>
          </div>
          <div className="flex shrink-0 gap-2">
            <Button size="sm" onClick={() => onContinue(d)} data-testid={`draft-continue-${d.area_id}`}>
              Continuar carga
            </Button>
            <Button size="sm" variant="outline" onClick={() => onDiscard(d)} data-testid={`draft-discard-${d.area_id}`}>
              Descartar
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};
